import type { InvoiceStatus } from '@shared/api/contracts';
import type { InvoiceStatusVariant } from '../model/types';

export const getInvoiceStatusVariant = (status: InvoiceStatus): InvoiceStatusVariant => {
  switch (status) {
    case 'paid':
      return 'success';
    case 'pending':
    case 'underpaid':
      return 'warn';
    case 'overpaid':
      return 'info';
    case 'expired':
    case 'error':
      return 'neutral';
    default:
      return 'neutral';
  }
};

export const INVOICE_STATUS_VARIANT_CLASSES: Record<InvoiceStatusVariant, string> = {
  pending: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
  success: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300',
  warn: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
  info: 'bg-sky-500/15 text-sky-700 dark:text-sky-300',
  neutral: 'bg-secondary text-muted-foreground',
};
